import http, { authHeaders } from '../../api/axios';

/**
 * Set parameters for download
 * @param apiGetFileUrl - get url
 * @param fileName - file name
 */
export const onDownloadItem = async (apiGetFileUrl: string, fileName?: string) => {
  await http
    .apiGetFiles({
      url: apiGetFileUrl,
      config: {
        headers: {
          ...authHeaders(),
          'Content-Type': 'application/json',
        },
        method: 'GET',
        responseType: 'blob',
      },
    })
    .then((response) => response?.data)
    .then(async (data) => {
      const fileUrl: string = URL.createObjectURL(data);
      downloadFile(fileUrl, fileName ?? 'file');
    });
};

/**
 * Downloads file
 * @param fileUrl
 * @param fileName
 */
export const downloadFile = (fileUrl: string, fileName: string) => {
  // Create a new link
  const anchor = document.createElement('a');
  anchor.href = fileUrl;
  anchor.download = fileName;
  // Append to the DOM
  document.body.appendChild(anchor);
  // Trigger `click` event
  anchor.click();
  // Remove element from DOM
  document.body.removeChild(anchor);
};
